export default __webpack_public_path__ + "assets/images/3c1109702b055e09345721ce5c0d8cf5.gif";